module.exports = __webpack_public_path__ + "static/media/mood_5.39da94ba.svg";